module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }